export default __webpack_public_path__ + "static/media/logo-mobile.51a53864.png";